<template>
  <div :class="twMerge('relative', props.rootClass)">
    <TsNuxtCard
        :append-class="twMerge('p-0', props.backClass)"
        v-if="props.bannerImage"
        noShadow noBorder
    >
      <slot name="back">
        <picture>
          <source media="(max-width: 768px)" :srcset="props.imgMobile">
          <source media="(min-width: 800px)" :srcset="props.imgDesktop">
          <TsImage v-if="props.bannerImage" :src="props.bannerImage" :width="isMobile ? '393' : '1280'" :height="isMobile ? '329' : '300'" class="w-full" alt="Chris standing up holding his daughter Elva" loading="lazy"/>
        </picture>
      </slot>
    </TsNuxtCard>
    <div :class="twMerge('w-11/12 mx-auto -mt-[100px] relative z-10', props.frontClass)">
      <slot name="front">
        <TsNuxtCard
            v-if="props.title || props.description"
            :title="props.title"
            :content="props.description"
            body-class="pb-1 pt-0"
            append-class="bg-natural-soft-white"
        >
          <template #header>
            <div :class="twMerge('flex items-center pb-2 border-b border-natural-light-grey')">
              <TsImage
                  v-if="props.icon"
                  :src="props.icon"
                  alt="Icon"
                  class="mr-2"
                  width="24"
                  height="24"
                  loading="lazy"
              />
              <TsTypography
                  as="p"
                  variant="h4"
                  append-class="mb-0"
              >
                {{ props.title }}
              </TsTypography>
            </div>
          </template>
        </TsNuxtCard>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import {twMerge} from "tailwind-merge";
const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);

const {isMobile} = useDevice();

type Props = {
  bannerImage?: string
  imgMobile?: string
  imgDesktop?: string
  sizes?: string
  title?: string
  icon?: string
  description?: string
  rootClass?: string
  backClass?: string
  frontClass?: string
}

const props = defineProps<Props>();
</script>